import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addItem } from '../services/cartSlice';
import ProductAPI from '../services/API';

const Product = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [product, setProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const data = await ProductAPI.getProduct(id);
        setProduct(data);
        setError(null);
      } catch (error) {
        console.error('Error fetching product:', error);
        setError('Failed to load product. Please try again later.');
      }
    };

    fetchProduct();
  }, [id]);

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen text-red-600 custom-font-text">
        {error}
      </div>
    );
  }

  if (!product) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        Loading...
      </div>
    );
  }

  const handleAddToCart = () => {
    dispatch(addItem({
      id: product.id,
      name: product.name,
      price: product.price,
      photos: product.photos || [product.photo] // Handle both arrays and single photo
    }));
  };

  // Handle both arrays of photos and single photo
  const photos = Array.isArray(product.photos) ? product.photos : [product.photo];

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Image Gallery */}
        <div className="space-y-4">
          <div className="aspect-square">
            <img
              src={photos[selectedImage]}
              alt={product.name}
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          {/* Thumbnail Gallery - only show if multiple photos exist */}
          {photos.length > 1 && (
            <div className="flex space-x-2 overflow-x-auto">
              {photos.map((photo, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedImage(index)}
                  className={`w-20 h-20 flex-shrink-0 ${
                    selectedImage === index ? 'ring-2 ring-accent' : ''
                  }`}
                >
                  <img
                    src={photo}
                    alt={`${product.name} thumbnail ${index + 1}`}
                    className="w-full h-full object-cover rounded"
                  />
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Product Details */}
        <div className="space-y-6">
          <h1 className="text-3xl font-bold custom-font-text italic">{product.name}</h1>
          <p className="text-2xl font-semibold">${product.price}</p>
          <div className="prose max-w-none">
            {product.description.split('\r\n\r\n').map((paragraph, index) => (
              <p key={index} className="mb-1">
                {paragraph.split('\r\n').map((line, lineIndex) => (
                  <React.Fragment key={lineIndex}>
                    {line}
                    {lineIndex < paragraph.split('\r\n').length - 1 && <br />}
                  </React.Fragment>
                ))}
              </p>
            ))}
          </div>
          <button
            onClick={handleAddToCart}
            className="w-full md:w-auto px-6 py-3 bg-accent text-white rounded-lg hover:bg-accent/80 transition-colors"
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default Product;